import { FormProvider } from 'react-hook-form';
import { TagSchema } from 'types/clientV2/tag';
import { useUpdateTagMutation } from 'store/slices/clientV2/tags';
import { ChipColor } from 'ui-component/extended/Chip';
import {
  createUpdateTagFormConstants,
  createUpdateTagValidationSchema,
} from 'views/properties/Tags/TagsTable/constants';
import useUpdateRecordDialog from 'hooks/useUpdateRecordDialog';
import CreateUpdateTagForm from 'views/properties/Tags/TagsTable/CreateUpdateTagForm';

interface UpdateTagDialogProps {
  tag: TagSchema | null;
  open: boolean;
  onClose: () => void;
}

const UpdateTagDialog = ({ tag, open, onClose }: UpdateTagDialogProps) => {
  const defaultValues = {
    [createUpdateTagFormConstants.name.id]: tag?.name || '',
    [createUpdateTagFormConstants.color.id]:
      tag?.color || ('default' as ChipColor),
    [createUpdateTagFormConstants.modelOptions.id]:
      tag?.modelOptions.map((item) => item.model) || [],
    [createUpdateTagFormConstants.active.id]: tag?.active || true,
    [createUpdateTagFormConstants.team.id]: tag?.team?.id || null,
  };

  const { methods, BaseUpdateRecordDialog, dialogProps } =
    useUpdateRecordDialog({
      formConstants: createUpdateTagFormConstants,
      validationSchema: createUpdateTagValidationSchema,
      useUpdateMutation: useUpdateTagMutation,
      newRecordDefaults: defaultValues,
      recordName: 'Tag',
      selectedRecord: tag,
      submitAsClientV2Api: true,
    });

  return (
    <BaseUpdateRecordDialog
      open={open}
      onClose={onClose}
      dialogProps={dialogProps}
    >
      <FormProvider {...methods}>
        <CreateUpdateTagForm defaultTeamId={tag?.team?.id || null} editMode />
      </FormProvider>
    </BaseUpdateRecordDialog>
  );
};

export default UpdateTagDialog;
